export const DebtorDocumentNumberType = [
  {
    id: '+1',
    label: '+1',
    country: 'US',
    icon: {
      path: '../../../assets/flags-icons/us-flag.svg',
      alt: 'USA flag'
    }
  },
  {
    id: '+51',
    label: '+51',
    country: 'PE',
    icon: {
      path: '../../../assets/flags-icons/peru-flag.svg',
      alt: 'Perú flag'
    }
  },
  {
    id: '+57',
    label: '+57',
    country: 'CO',
    icon: {
      path: '../../../assets/flags-icons/colombia-flag.svg',
      alt: 'Colombia flag'
    }
  },
  {
    id: '+54',
    label: '+54',
    country: 'AR',
    icon: {
      path: '../../../assets/flags-icons/argentina-flag.svg',
      alt: 'Argentina flag'
    }
  },
  {
    id: '+591',
    label: '+591',
    country: 'BO',
    icon: {
      path: '../../../assets/flags-icons/bolivia-flag.svg',
      alt: 'Bolivia flag'
    }
  },
  {
    id: '+55',
    label: '+55',
    country: 'BR',
    icon: {
      path: '../../../assets/flags-icons/brazil-flag.svg',
      alt: 'Brasil flag'
    }
  },
  {
    id: '+56',
    label: '+56',
    country: 'CL',
    icon: {
      path: '../../../assets/flags-icons/chile-flag.svg',
      alt: 'Chile flag'
    }
  },
  {
    id: '+593',
    label: '+593',
    country: 'EC',
    icon: {
      path: '../../../assets/flags-icons/ecuador-flag.svg',
      alt: 'Ecuador flag'
    }
  },
  {
    id: '+595',
    label: '+595',
    country: 'PY',
    icon: {
      path: '../../../assets/flags-icons/paraguay-flag.svg',
      alt: 'Paraguay flag'
    }
  },
  {
    id: '+598',
    label: '+598',
    country: 'UY',
    icon: {
      path: '../../../assets/flags-icons/uruguay-flag.svg',
      alt: 'Uruguay flag'
    }
  },
  {
    id: '+58',
    label: '+58',
    country: 'VE',
    icon: {
      path: '../../../assets/flags-icons/venezuela-flag.svg',
      alt: 'Venezuela flag'
    }
  },
  {
    id: '+52',
    label: '+52',
    country: 'MX',
    icon: {
      path: '../../../assets/flags-icons/mexico-flag.svg',
      alt: 'México flag'
    }
  }
];
